// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_n0-0";
export var buttonContainer = "_n0-3";
export var cancelButton = "_n0-4";
export var headerSection = "_n0-6";
export var headerTitle = "_n0-9";
export var messageSideLeft = "_n0-1";
export var messageSideRight = "_n0-2";
export var orderNumberContainer = "_n0-7";
export var orderNumberLabel = "_n0-8";
export var submitButton = "_n0-5";